import * as React from 'react';
import { useState, useEffect } from 'react';
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router";


import List from '@mui/material/List';

import { SlotsTable } from './SlotsTable';
import ToggleDays from './ToggleDays'
import { getProviderArray } from '../Helper/utils';
import { ToastEmitter } from '../ToastEmitter';
import { createOrUpdateDoctorDetails, getDoctorDetails } from '../Helper/API';
import { doctorListURL, SOME_THING_WENT_WRONG, DOCTOR_PROFILE_SAVED_SUCCESS } from '../constant';
import { BackdropLoader } from '../BackdropLoader';
import { logEventToAnalyticsPlatform, fetchUserDetailsAndSetUserForAnalytics } from "../../../helper/events"
import { EVENTS } from "../events_Constant"
import { TableStyle } from '../StyledComponent'
import { SlotsPreview } from './SlotsPreview';



export const DoctorSlot = ({ setDoctorProfileDetails, doctorProfileDetails, QCEnableOnSlots }) => {

    const history = useHistory();
    const [doctorSlots, setDoctorSlots] = useState();
    const originalSlots = doctorProfileDetails?.doctors[0]?.doctorSlots || [];
    const parentId = doctorProfileDetails?.doctors[0]?.providerId;
    const [isLoading, setIsLoading] = useState(false);

    const {
        control,
        handleSubmit,
        formState: { isDirty },
        reset,
        setValue,
        register
    } = useForm();

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const doctorId = queryParams.get('drId') || doctorProfileDetails?.doctors[0]?.doctorId || '';
    const [isProfileStatusDraft, setIsProfileStatusDraft] = useState(true);

    useEffect(() => {
        setDoctorSlots(doctorProfileDetails?.doctors[0]?.doctorSlots);
        if (doctorProfileDetails?.doctors[0]?.doctorQCStatus) {
            if (doctorProfileDetails?.doctors[0]?.doctorQCStatus.toLowerCase() != 'draft')
                setIsProfileStatusDraft(false);
        }
    }, [doctorProfileDetails])

    useEffect(() => {
        const triggerEvents = async () => {
            await fetchUserDetailsAndSetUserForAnalytics();
            logEventToAnalyticsPlatform({
                name: EVENTS.PC_SCREEN_LANDING.name,
                payload: {
                  tab_name: EVENTS.TAB_NAME_ADD_EDIT_SCHEDULE,
                  service_type: EVENTS.SERVICE_TYPE_OFFLINE_CONSULTS,
                  screenName: EVENTS.SERVICE_NAME_OFFLINE_CONSULTS,
                },
                schema: EVENTS.PC_SCREEN_LANDING.schema,
              })
        }
        triggerEvents();

    }, [])


    const submitAndProceed = async () => {
        try {
            const providerArray = getProviderArray();
            let days = doctorSlots.map((item) => item.dayOfWeek);
            let originalSlotsToDeactivate = originalSlots.filter((item) => !days.includes(item.dayOfWeek)) ?? [];
            if (originalSlotsToDeactivate.length > 0) {
                originalSlotsToDeactivate = originalSlotsToDeactivate.map((item) => {
                    return { ...item, isActive: false };
                });
            }
            let data = {
                providerIds: providerArray,
                doctors: [{
                    doctorId: parseInt(doctorId),
                    doctorSlots: [...doctorSlots, ...originalSlotsToDeactivate]
                }]
            };
            data.doctors[0].doctorSlots = data.doctors[0].doctorSlots.map(({ id, ...rest }) => rest);
            let updatedDoctorProfileDetails = doctorProfileDetails.doctors[0];
            if (updatedDoctorProfileDetails.doctorQCStatus.toLowerCase() == 'draft' && QCEnableOnSlots) {
                updatedDoctorProfileDetails.doctorSlots = doctorSlots;
                updatedDoctorProfileDetails.doctorQCStatus = 'InProgress';
                data = {
                    providerIds: providerArray,
                    doctors: [updatedDoctorProfileDetails]
                }
            }
            setIsLoading(true);
            const response = await createOrUpdateDoctorDetails(data);
            if (response.success) {
                const updatedProfileDetails = doctorProfileDetails?.doctors ? doctorProfileDetails?.doctors[0] : null;
                ToastEmitter(DOCTOR_PROFILE_SAVED_SUCCESS, 'success');
                logEventToAnalyticsPlatform({
                    name: EVENTS.PC_LS_ACTION.name,
                    payload: {
                        tab_name: EVENTS.TAB_NAME.ADD_SCHEDULE,
                        filterValue: '',
                        reference_id: "" + updatedProfileDetails?.doctorId || '',
                        reference_provider_id: "" + updatedProfileDetails?.providerId || '',
                        reference_provider_name: updatedProfileDetails?.providerName || '',
                        service_name: EVENTS.SERVICE_NAME_OFFLINE_CONSULTS,
                        action: EVENTS.ACTION.SCHEDULE_CREATED,
                    },
                    schema: EVENTS.PC_LS_ACTION.schema,
                })
                history.push(doctorListURL);
                return;
            }
            else {
                ToastEmitter(SOME_THING_WENT_WRONG, 'error');
            }
        }
        catch (err) {
            ToastEmitter(SOME_THING_WENT_WRONG, 'error');
        }
        finally {
            setIsLoading(false);
        }
    }

    const markFormDirty = () => {
        setValue('doctorSlot', doctorSlots, { shouldDirty: true });
    }

    return (

        <>
            {isLoading && <BackdropLoader isLoading={isLoading} />}
            <List sx={TableStyle} className='w-[80vw] '>
                <form >
                    <div className='flex flex-col gap-2 bg-white '>
                        <input type="hidden" {...register('doctorSlot')} />
                        <ToggleDays doctorSlots={doctorSlots} setDoctorSlots={setDoctorSlots} makeFormDirty={markFormDirty} parentId={parentId} />
                        <div className="pt-4">
                            <SlotsTable doctorSlots={doctorSlots} setDoctorSlots={setDoctorSlots} makeFormDirty={markFormDirty} parentId={parentId} />
                        </div>


                        <div className="flex flex-row justify-end gap-2 px-4 py-6 text-sm font-semibold bg-[#FFFFFF] ">
                            <button className="flex flex-col justify-center border rounded-lg px-6 py-2 border-[#DBE0E6] font-semibold "
                                onClick={(e) => { e.preventDefault(); history.push(doctorListURL) }}>
                                Close
                            </button>
                            <SlotsPreview doctorSlots={doctorSlots}  doctorProfileDetails={doctorProfileDetails}/>
                            <button
                                className={`${(doctorSlots && doctorSlots.length > 0) && (QCEnableOnSlots || (doctorId && isDirty)) ? ' border-blue-700 text-white bg-blue-600 ' : ' bg-[#F5F7F8] border-[#DBE0E6] '} "flex flex-col justify-center py-2 px-4 border rounded-lg "`}
                                style={{ color: (doctorSlots && doctorSlots.length > 0) && (QCEnableOnSlots || (doctorId && isDirty)) ? 'white' : '#A4B0C0' }}
                                disabled={(doctorSlots && doctorSlots.length > 0) && (QCEnableOnSlots || (doctorId && isDirty)) ? false : true}
                                onClick={(e) => { e.preventDefault(); e.stopPropagation(); submitAndProceed() }}>
                                {isProfileStatusDraft && QCEnableOnSlots ? 'Submit to QC' : 'Save'}
                            </button>
                        </div>
                    </div>
                </form >
            </List >
        </>
    );
}



